<template>
    <div class="col-sm-4 px-0 mb-4 currency input-group d-flex align-items-center">
        <span class="mr-auto">{{ label }}</span>
        <div class="number-input align-items-center d-flex mr-4">
            <img @click="stepDownFrom()" src="@/assets/svg/minus-767676.svg">
            <input v-model="fromValue" type="number" class="mb-0">
            <img @click="stepUpFrom()"  src="@/assets/svg/plus-767676.svg">
        </div>
        <div class="number-input align-items-center d-flex">
            <img @click="stepDownUntil()" src="@/assets/svg/minus-767676.svg">
            <input v-model="untilValue" type="number" class="mb-0">
            <img @click="stepUpUntil()"  src="@/assets/svg/plus-767676.svg">
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      counterFrom: this.amountFrom,
      counterUntil: this.amountUntil
    }
  },
  props: {
    label: {
      default: '',
      type: String,
      required: false
    },
    amountFrom: {
      default: 0,
      type: String | Number,
      required: false
    },
    amountUntil: {
      default: 0,
      type: String | Number,
      required: false
    },
    min: {
      default: 0,
      type: String | Number,
      required: false
    },
    max: {
      default: 60,
      type: String | Number,
      required: false
    }
  },
  computed: {
    fromValue: {
      get () {
        if (parseInt(this.min) > 0) {
          return parseInt(this.min)
        } else {
          return parseInt(this.amountFrom)
        }
      },
      set (value) {
        this.counterFrom = value
      }
    },
    untilValue: {
      get () {
        if (parseInt(this.min) > 0) {
          return parseInt(this.min)
        } else {
          return parseInt(this.amountUntil)
        }
      },
      set (value) {
        this.counterUntil = value
      }
    }
  },
  methods: {
    stepUpFrom () {
      this.counterFrom++
    },
    stepDownFrom () {
      this.counterFrom--
    },
    stepUpUntil () {
      this.counterUntil++
    },
    stepDownUntil () {
      this.counterUntil--
    }
  },
  watch: {
    counterFrom (val) {
      this.$emit('update:amountFrom', val)
    },
    counterUntil (val) {
      this.$emit('update:amountUntil', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/NumberRangeInput.vue